// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logo-height[data-v-b419b642]{max-height:48px;width:150px}.avatar-bg[data-v-b419b642]{padding:4px!important}.speed-dial[data-v-b419b642]{right:0!important;top:0!important}.menu-margin-top[data-v-b419b642]{margin-top:6px impo!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
